module.exports = __webpack_public_path__ + "static/media/cert_97.1cfdeded.jpg";